import React, { useState } from 'react';
import { StarIcon, FileTextIcon, BarChart2Icon } from 'lucide-react';
const TeamHeader = () => {
  const [isFavorite, setIsFavorite] = useState(false);
  const teamData = {
    name: 'New York Knicks',
    league: 'NBA',
    conference: 'Eastern Conference',
    division: 'Atlantic Division',
    founded: '1946',
    arena: 'Madison Square Garden',
    officialSite: 'https://www.nba.com/knicks',
    social: {
      twitter: '@nyknicks',
      instagram: '@nyknicks',
      facebook: 'NewYorkKnicks'
    }
  };
  return <div className="mb-6" data-id="element-315" data-mp="lo5cvbt02k74">
      {/* Title row outside the box */}
      <div className="flex justify-between items-center mb-4" data-id="element-316" data-mp="gnri2vget6r1">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-317" data-mp="gqdkkgog0w2e">
          {teamData.name}
        </h1>
        <div className="flex items-center space-x-2" data-id="element-318" data-mp="31erxz0j6bm75">
          <button onClick={() => setIsFavorite(!isFavorite)} className={`p-2 rounded-full ${isFavorite ? 'text-yellow-500' : 'text-gray-400 hover:bg-gray-200'}`} data-id="element-319" data-mp="31fkvdaw8szcm">
            <StarIcon className="w-5 h-5" fill={isFavorite ? 'currentColor' : 'none'} data-id="element-320" data-mp="2c1c2pdu9n0sb" />
          </button>
          <button className="p-2 rounded-full text-gray-400 hover:bg-gray-200" data-id="element-321" data-mp="2g3yvpi2oarr3">
            <FileTextIcon className="w-5 h-5" data-id="element-322" data-mp="223xycclma2gd" />
          </button>
          <button className="p-2 rounded-full text-gray-400 hover:bg-gray-200" data-id="element-323" data-mp="223fv2w0jenyy">
            <BarChart2Icon className="w-5 h-5" data-id="element-324" data-mp="271hexj5serbh" />
          </button>
        </div>
      </div>
      {/* Box removed from here - it will be added to TeamHero.tsx */}
    </div>;
};
export default TeamHeader;